module.exports = __webpack_public_path__ + "img/huntica-logo.6e61cdf3.png";